import { useEffect, useMemo } from "react";
import { Badge } from "reactstrap";
import { useSideChannelSubscription } from "../../util/useSideChannel";
import { useAppliedFormatter } from "../../util/applyFormatting";
import { useJnx } from "../../util/jnx";
import getPathFromId from "../../util/getPathFromId";

const colorsByStatus = {
  'In Progress': 'warning',
  'Pending Allocation': 'secondary',
  'Completed': 'success',
  'Confirmed': 'info',
  'Missed': 'danger',
}

function ShiftInstanceAllocationStatus(props) {
    const {
      formContext,
      schema,
      onChange,
      idSchema: { $id },
    } = props;

    const {
        format,
        jsonata: jsonataComputation,
        updateIf: updateIfExpr,
        onUpdate,
    } = schema;

    const {
        sideChannel,
        bindings: fcBindings,
        setFormDataValues,
    } = formContext;

    const [rootFormData, formObject] = useSideChannelSubscription(sideChannel, [0, 1]) || [{}, {}];

    const bindings = useMemo(() => ({
        ...fcBindings,
        formObject,
        formContext
    }), [fcBindings, formObject, formContext]);

    const path = useMemo(() => getPathFromId($id), [$id]);
    const valueJnx = useJnx(jsonataComputation);

    const value = useMemo(() => {
      const context = { ...rootFormData, lookupOptions: {} }
      return valueJnx.eval(context, path, {...bindings });
    }, [rootFormData, valueJnx, path, bindings])

    const hasReasonForLeaving = useMemo(() => {
      return value && value.reasonForLeaving && value.reasonForLeaving.length > 0
    }, [value])

    const status = useMemo(() => {
      if (!value || !value.status) return ''
      if (value.status === 'Completed' && value.autoClockout) {
        return 'Completed (ACO)'
      }
      return value.status
    }, [value])
  
    const statusColor = useMemo(() => {
      if (!value || !value.status) return 'secondary'
      if (value.status === 'Completed' && value.autoClockout) {
        return 'danger'
      }
      return colorsByStatus[value.status]
    }, [value])
  
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
        <Badge color={statusColor} style={{ fontSize: "100%" }}>
          {status}
        </Badge>
        {hasReasonForLeaving && (
          <span style={{ width: 'fit-content', whiteSpace: "nowrap" }}>Reason for leaving: {value.reasonForLeaving}</span>
        )}
      </div>
    )
}

export default ShiftInstanceAllocationStatus;